import { Patient } from '../../models/patient';
import GetPatientDetails from '../../services/patients/getPatientsDetails';

export const getPatient = (setPatient: (p: Patient) => void) => async (patientId: string) => {
  const { patient } = await GetPatientDetails(patientId);
  setPatient(patient);
  return patient;
};
